import React from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { IconProp } from "@fortawesome/fontawesome-svg-core";

import styles from "./FacilityBorderedBtn.module.scss";

type Props = {
  onClick: () => void;
  icon?: IconProp;
  text?: string;
  cls?: string;
};

const BorderedBtn: React.FC<Props> = ({ onClick, icon, text, cls }) => {
  return (
    <button
      className={`${styles["f-borderedBtn"]} ${cls ? styles[cls] : ""}`}
      onClick={onClick}
    >
      {icon && <FontAwesomeIcon icon={icon} />}
      {text && <p>{text}</p>}
    </button>
  );
};

export default BorderedBtn;
